import BaseModel from "./BaseModel";
import SellingMaterial from "./SellingMaterial";

/**
 * SellingMaterialGroup
 */
export default class SellingMaterialGroup extends BaseModel{
  constructor({
    id,
    title,
    description,
    price,
    status,
    benefits,
    created_at,
    updated_at,
    sellingMaterials,
    isMine
  }) {
    super();

    this.id = id || null;
    this.title = title || null;
    this.description = description || null;
    this.price = price || null;
    this.status = status || null;
    this.benefits = benefits ? JSON.parse(benefits) : null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.sellingMaterials = this.hydrate(sellingMaterials);
    this.isMine = isMine || false;
  }

  /**
   * Parses SellingMaterials to objects
   * @param {Array} sellingMaterials 
   * @returns {Array<SellingMaterial>}
   */
  hydrate(sellingMaterials = []) {
    let thisMaterials = [];

    for (let sellingMaterialData of sellingMaterials) {
      thisMaterials.push(new SellingMaterial(sellingMaterialData));
    }

    return thisMaterials;
  }

  /**
   * Gets if SellingMaterialGroup has sellingMaterials
   * @returns {Boolean}
   */
  hasSellingMaterials() {
    return !Array.isArray(this.sellingMaterials) ? false : (this.sellingMaterials.length > 0);
  }

  /**
   * Returns SellingMaterialGroup.isMine
   * @returns {Boolean}
   */
  isMyMaterial() {
    return this.isMine ? true : false;
  }
}
